module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraBold.19ba7aa5.ttf";